import { combine } from 'react-hooks-combine'

import TeamViewComponent from './component'

export const TeamView = combine({
  transformProps: ({ match }) => ({
    teamId: Number(match.params.teamId),
  }),
})(TeamViewComponent)
